enum Sections {
  Gallery = 'gallery',
  Hero = 'hero',
  Vehicles = 'vehicles',
  Root = 'root',
  Spinner = 'spinner-container',
  ValueTracker = 'value-tracker',
  Video = 'video'
}

export default Sections;
